module.exports = __webpack_public_path__ + "static/media/6akcesoria.adc7f23e.png";